module.exports = __webpack_public_path__ + "images/emoji/rice_cracker.58e7922ad1aba876d9f5.png";